// src/App.tsx
import React from 'react';

// On importe maintenant le Header complet (qui inclut TopBar + MainHeader)
import Header from './components/Header'; // 👈 Ici on importe le Header principal qui combine les deux parties

import Footer from './components/Footer';
import CustomCursor from './components/ui/CustomCursor';
import './App.css';
import Home from './pages/Home';

function App() {
  return (
     <div className="App">
      {/* Curseur personnalisé */}
      <CustomCursor /> {/* ✅ Ajouté ici */}

      {/* En-tête */}
      <Header />

      {/* Contenu principal */}
      <main className="flex-grow">
        <Home />
      </main>

      {/* Sections fixes */}
      
      <Footer />
    </div>
  );
}

export default App;